import React from 'react';
import { FaTimesCircle, FaCheck, FaInfoCircle, FaExclamationTriangle, FaQuestionCircle } from 'react-icons/fa';

export const Alert = ({ variant = 'success', children, className = '', icon = true, style = {}, ...rest }) => {
    let IconComponent = false;
    if (icon) {
        switch (variant) {
            case 'success':
                IconComponent = FaCheck;
                break;
            case 'danger':
                IconComponent = FaTimesCircle;
                break;
            case 'warning':
                IconComponent = FaExclamationTriangle;
                break;
            case 'info':
                IconComponent = FaInfoCircle;
                break;
            case 'primary':
            case 'secondary':
            case 'light':
            case 'dark':
                IconComponent = FaQuestionCircle;
                break;
            default:
                IconComponent = FaQuestionCircle;
        }
    }

    return (
        <div className={`alert alert-${variant} ${className}`} style={{ ...style, position: 'relative' }} {...rest} role="alert">
            {IconComponent && <IconComponent size="18" style={{ marginRight: 8, verticalAlign: 'text-bottom' }} />}
            {children}
        </div>
    );
};
